document.addEventListener('DOMContentLoaded', () => {
  const mainArea = document.getElementById('product-main-media');
  const thumbs = document.querySelectorAll('.product-thumbnail img');
  const slides = Array.from(document.querySelectorAll('.slider__slide img')).slice(1);
  const nextBtn = document.querySelector('.slider-button--next');
  const prevBtn = document.querySelector('.slider-button--prev');
  let current = 0;

  //  動画表示中はスワイプでスライド切替しないためのロック
  let swipeLocked = false;

  function renderMediaFromEl(el) {
    const type = el.dataset.type;
    const imageSrc = el.dataset.image;
    const videoSrc = el.dataset.video;
    const posterSrc = el.dataset.poster;

    // 一旦クリア
    mainArea.style.opacity = 0;

    setTimeout(() => {
      mainArea.innerHTML = '';

      if (type === 'video' && videoSrc) {
        //  動画のときはスワイプ無効（誤切替防止）
        swipeLocked = true;

        const wrap = document.createElement('div');
        wrap.className = 'main-video-wrap';

        const video = document.createElement('video');
        video.src = videoSrc;
        video.controls = true;
        video.playsInline = true;
        video.preload = 'metadata'; // 黒枠対策

        // poster（サムネ）を指定して黒枠を出にくくする
        if (posterSrc) {
          video.poster = posterSrc;
        }

        // ▶︎ 再生オーバーレイボタン
        const playBtn = document.createElement('button');
        playBtn.type = 'button';
        playBtn.className = 'main-video-play';
        playBtn.setAttribute('aria-label', '動画を再生');
        playBtn.innerHTML = '▶';

        //  ボタン操作がスワイプ判定に拾われないように止める
        playBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          video.play();
        });

        playBtn.addEventListener('touchstart', (e) => {
          e.preventDefault();
          e.stopPropagation();
        }, { passive: false });

        // 再生中は非表示、停止/終了で表示
        video.addEventListener('play', () => {
          playBtn.classList.add('is-hidden');
        });
        video.addEventListener('pause', () => {
          playBtn.classList.remove('is-hidden');
        });
        video.addEventListener('ended', () => {
          playBtn.classList.remove('is-hidden');
        });

        wrap.appendChild(video);
        wrap.appendChild(playBtn);
        mainArea.appendChild(wrap);
      } else {
        //  画像のときはスワイプ有効
        swipeLocked = false;

        const img = document.createElement('img');
        img.src = imageSrc || el.src;
        img.alt = el.alt || '';
        img.style.width = '100%';
        img.style.height = '100%';

        mainArea.appendChild(img);
      }

      mainArea.style.opacity = 1;
    }, 200);
  }

  function showSlide(index) {
    current = index;
    const targetEl = slides[index];
    renderMediaFromEl(targetEl);

    thumbs.forEach(t => t.classList.remove('active'));
    thumbs[index + 1]?.classList.add('active'); // +1 → サムネも1枚目除外
  }

  thumbs.forEach((thumb, idx) => {
    if (idx === 0) return; // 1枚目のサムネは無視
    thumb.addEventListener('click', () => showSlide(idx - 1));
  });

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      showSlide((current + 1) % slides.length);
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      showSlide((current - 1 + slides.length) % slides.length);
    });
  }

  // swipe
  let startX = 0;
  let endX = 0;
  const slider = document.querySelector('.custom-product-gallery');

  if (slider) {
    slider.addEventListener('touchstart', (e) => {
      if (swipeLocked) return; //  動画中はスワイプ無効
      startX = e.touches[0].clientX;
      endX = startX; // 念のため初期化
    });

    slider.addEventListener('touchmove', (e) => {
      if (swipeLocked) return; //  動画中はスワイプ無効
      endX = e.touches[0].clientX;
    });

    slider.addEventListener('touchend', () => {
      if (swipeLocked) return; //  動画中はスワイプ無効

      const threshold = 50;
      const diff = startX - endX;

      if (diff > threshold) {
        // 左へスワイプ → 次へ
        nextBtn?.click();
      } else if (diff < -threshold) {
        // 右へスワイプ → 前へ
        prevBtn?.click();
      }
    });
  }

  // 最初を表示
  showSlide(0);
});

// 商品詳細アコーディオン
$(function(){
  $('.accordion-header').click(function() {
    $(this).next().slideToggle();
    $(this).toggleClass('active');
  });
});

// FAQアコーディオン
$(function(){
  $('.faq-header').click(function() {
    $(this).next().slideToggle();
    $(this).toggleClass('active');
  });
});

// レビューのブロック位置を移動（PC/SPで出し分けしている場合に対応）
document.addEventListener('DOMContentLoaded', () => {
  const mq = window.matchMedia('(max-width: 749px)'); // DawnのSP境界に合わせる

  const findWidget = () =>
    document.querySelector('#judgeme_product_reviews') ||
    document.querySelector('.jdgm-review-widget') ||
    document.querySelector('.jdgm-widget.jdgm-review-widget');

  const pickSlot = () => {
    // 画面幅に応じて、優先するslotを変える
    const preferred = mq.matches
      ? document.querySelector('.sp [id^="jdgm-slot-"]')
      : document.querySelector('.pc [id^="jdgm-slot-"]');

    if (preferred) return preferred;

    // 念のためフォールバック（見えているslotを優先）
    const slots = Array.from(document.querySelectorAll('[id^="jdgm-slot-"]'));
    return slots.find(el => el.getClientRects().length > 0) || slots[0] || null;
  };

  let rafId = 0;
  const moveJudgeMeWidget = () => {
    const widget = findWidget();
    const slot = pickSlot();
    if (!widget || !slot) return;

    // すでに正しいslotに入っていたら何もしない
    if (widget.parentElement === slot) return;

    slot.appendChild(widget);
  };

  const scheduleMove = () => {
    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(moveJudgeMeWidget);
  };

  // 初回
  scheduleMove();

  // Judge.meが後からDOMに挿入されることがあるので監視
  const observer = new MutationObserver(scheduleMove);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // 画面幅が変わった時（端末回転/リサイズ）も移動し直す
  if (mq.addEventListener) mq.addEventListener('change', scheduleMove);
  else mq.addListener(scheduleMove);

  window.addEventListener('resize', scheduleMove);
});

// お支払いボタンを擬似的に作成して、別のお支払い方法ボタンを開く
document.addEventListener("click", (e) => {
  const btn = e.target.closest(".more-payment-options-btn");
  if (!btn) return;

  // 同じ購入フォーム内の accelerated checkout を探す
  const wrapper = btn.closest(".product-form__buttons");
  if (!wrapper) return;

  const link = wrapper.querySelector("#more-payment-options-link");
  if (!link) return;

  e.preventDefault();
  link.click();
});      

// 購入手続きのボタン処理　カートに商品が入ってからcheckoutへ移動
document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".js-add-and-checkout");
  if (!btn) return;

  if (btn.disabled) return;

  e.preventDefault();

  const formId = btn.dataset.formId;
  const form = formId ? document.getElementById(formId) : null;

  if (!form) {
    console.warn("Product form not found:", formId);
    return;
  }

  // 現在選択されている variant id（フォーム内 hidden input）
  const variantInput = form.querySelector('input[name="id"]');
  const variantId = variantInput?.value;

  // 数量（Dawnは form="product-form-xxx" で外にあることが多い）
  const qtyInput =
    document.querySelector(`input[name="quantity"][form="${formId}"]`) ||
    form.querySelector('input[name="quantity"]');

  const quantity = Math.max(1, parseInt(qtyInput?.value || "1", 10));

  if (!variantId) {
    console.warn("Variant id not found");
    return;
  }

  btn.disabled = true;

  try {
    // 1) カートに追加（既にカートに商品があっても加算される）
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: Number(variantId),
        quantity,
      }),
    });

    // 2) checkoutへ（カート内まとめて購入）
    window.location.href = "/checkout";
  } catch (err) {
    console.error(err);
    btn.disabled = false;
    alert("カート追加に失敗しました。もう一度お試しください。");
  }
});
